/** Accept the documented ISO dates and epoch seconds used by the live server. */
export function normalizeApiDate(value: string | number | null | undefined): string | null {
  if (value == null || value === "") return null
  const numeric = typeof value === "number" ? value : Number(value)
  const date = new Date(Number.isFinite(numeric)
    ? (Math.abs(numeric) < 1_000_000_000_000 ? numeric * 1000 : numeric)
    : value)
  return Number.isNaN(date.getTime()) ? null : date.toISOString()
}
